import { createContext, useContext, useState, ReactNode } from 'react';

interface SelectionContextType {
  selectedDataSources: string[];
  setSelectedDataSources: (sources: string[]) => void;
}

const useSelectionContextContext = createContext<SelectionContextType | undefined>(undefined);

export function SelectionContextProvider({ children }: { children: ReactNode }) {
  const [selectedDataSources, setSelectedDataSources] = useState<string[]>([]);
  return (
    <useSelectionContextContext.Provider value={{ selectedDataSources, setSelectedDataSources }}>
      {children}
    </useSelectionContextContext.Provider>
  );
}

export function useSelectionContext() {
  const context = useContext(useSelectionContextContext);
  if (!context) {
    throw new Error('useSelectionContext must be used within a SelectionContextProvider');
  }
  return context;
}
